import { NavigationDropdown } from "@components/general/NavigationDropdown/NavigationDropdown";
import { FC } from "react";
import { OrganizationSwitcher } from "@components/general/NavigationDropdown/OrganizationSwitcher";
import { useOrganizations } from "@api/organization.api";
import { Dropdown } from "react-bootstrap";
import { PersonalViewNavigationDropdownToggle } from "./PersonalViewNavigationDropdownToggle";

export const PersonalViewNavigationDropdown: FC = () => {
    const userOrganizations = useOrganizations();

    const hasAccessToAnyOrganization =
        (userOrganizations.data?.length ?? 0) > 0;

    return (
        <NavigationDropdown toggle={PersonalViewNavigationDropdownToggle}>
            {hasAccessToAnyOrganization && (
                <>
                    <OrganizationSwitcher />
                    <Dropdown.Divider />
                </>
            )}
        </NavigationDropdown>
    );
};
